<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <p @click="$router.go(-1)" class="back">back</p>
      <md-card>
        <md-card-content v-if="location" class="md-layout md-gutter">
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Name</label>
              <md-input v-model="location.name" type="text"></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <vue-google-autocomplete
                types
                id="input_address"
                class="md-layout-item md-size-100 form-control"
                placeholder="Address 1"
                v-on:placechanged="setInput_address"
                v-model="location.address.address_1"
                v-on:error="handleError"
              ></vue-google-autocomplete>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Address 2</label>
              <md-input v-model="location.address.address_2" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Address 3</label>
              <md-input v-model="location.address.address_3" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Zip</label>
              <md-input v-model="location.address.zip" type="text"></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>City</label>
              <md-input v-model="location.address.city" type="text" id="locality"></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>State</label>
              <md-input v-model="location.address.state" type="text"></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Country</label>
              <md-input v-model="location.address.country" type="text"></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <md-button class="md-primary md-round md-small" @click="validate()">Save</md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<!-- import google places api -->
<script
  src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDmxEslCaOETvFzT-EQx10gHIrcAcnSaxw&libraries=places&callback=initAutocomplete"
  async
  defer
></script>

<script>
import { db } from "@/config/firebaseInit";
import Swal from "sweetalert2";

//second try, diff way using VueGoogleAutocomplete
// import VueGoogleAutocomplete to allow google places autocomplete to work
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  //use as a component
  components: { VueGoogleAutocomplete },
  data() {
    return {
      batch: db.batch(),
      //input_address - used to save data imported from google places api
      input_address: {},

      location: {
        name: "",
        address: {
          address_1: "",
          address_2: "",
          address_3: "",
          zip: "",
          city: "",
          state: "",
          country: "",
          coords: {
            lat: 0,
            lng: 0,
          },
        },
      },
      selectCalled: false,
    };
  },
  firestore() {
    return {
      location: db.collection("location").doc(this.$route.params.location_id),
    };
  },
  created() {
    let locationId = this.$route.params.location_id;
    let locationTemplate = Object.assign({}, this.location);

    this.$bind("location", db.collection("location").doc(locationId)).then(
      () => {
        if (!this.location) {
          this.location = locationTemplate;
        }
      }
    );
  },

  methods: {
    //Takes in data imported from google places API and saves them into the address form
    setInput_address(input_address, placeResultData, id) {
      //input_address and placeResultData hold JSON Objects with address information obtained from the google places API
      this.input_address = input_address;

      if (
        this.input_address.street_number == null &&
        this.input_address.route == null
      ) {
        this.location.address.address_1 = "";
      } else if (this.input_address.street_number == null) {
        this.input_address.route == null;
      } else if (this.input_address.route == null) {
        this.input_address.street_number == null;
      } else {
        this.location.address.address_1 =
          this.input_address.street_number + " " + this.input_address.route;
      }
      this.location.address.zip = this.input_address.postal_code;
      //for city and state the to access the information I had to dig in a little bit into placeResultData
      this.location.address.city =
        placeResultData.address_components[3].short_name;
      this.location.address.state =
        placeResultData.address_components[5].short_name;
      this.location.address.country = this.input_address.country;
      this.location.address.coords.lat = this.input_address.latitude;
      this.location.address.coords.lng = this.input_address.longitude;
    },
    handleError(error) {
      alert(error);
    },
    validate() {
      let valid = true;
      let location = this.location;
      let address = location.address;
      if (!location.name) {
        valid = false;
      }

      for (let key in address) {
        if (key !== "address_2" && key !== "address_3") {
          if (!address[key]) {
            valid = false;
          }
        }
      }

      if (valid) {
        this.save();
      } else {
        return Swal.fire("Missing Fields", "Please enter all required fields");
      }
    },
    save() {
      let vm = this;
      if (this.location && !this.location.created) {
        this.location.created = Date.now();
      }
      return db
        .collection("location")
        .doc(this.$route.params.location_id)
        .set(vm.location, { merge: true })
        .then(() => {
          this.batch.commit();
        })
        .then(() => {
          this.batch = db.batch();
          Swal.fire("Success", "Page Updated", "success").then(() => {
            this.$router.go(-1);
          });
        });
    },
    updateGalleries(ref, data) {
      if (data === null) {
        this.batch.delete(ref);
      } else {
        this.batch.set(ref, data, { merge: true });
      }
    },
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
